import { useEffect, useState } from 'react';

import classes from './header.module.css';
import LogoMark from './logo';

const Header = () => {
    const [lifted, setLifted] = useState(false);

    useEffect(() => {
        const onScroll = () => setLifted(window.scrollY > 24);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <header className={`${classes.header} ${lifted ? classes.lifted : ''}`}>
            <div className={classes.inner}>
                <a className={classes.brand} href="/" aria-label="PrepAnywhere home">
                    <LogoMark size={28} className={classes.mark} />
                    <span className={classes.wordmark}>PrepAnywhere</span>
                </a>

                <nav className={classes.nav} aria-label="Primary">
                    <a href="#belief">Belief</a>
                    <a href="#mission">Mission</a>
                    <a href="#loop">How it works</a>
                    <a href="#products">Products</a>
                </nav>
            </div>
        </header>
    );
};

export default Header;
